/**
* @file 运营中心-用户反馈
* */
<template>
  <div id="adverseRecord">
    <!-- 统计 -->
    <div class="statistics" v-loading="loading">
      <div class="statistics-item">
        <el-card>
          <div class="statistics-title">审核次数</div>
          <div class="statistics-content">
            <div class="statistics-block">
              <span class="label">本月：</span>
              <el-statistic :value="statsData.thisMonthCount" suffix="次" :precision="0"></el-statistic>
            </div>
            <div class="statistics-block">
              <span class="label">上月：</span>
              <el-statistic :value="statsData.lastMonthCount" suffix="次" :precision="0"></el-statistic>
            </div>
          </div>
        </el-card>
      </div>
      <div class="statistics-item">
        <el-card>
          <div class="statistics-title">账单金额</div>
          <div class="statistics-content">
            <div class="statistics-block">
              <span class="label">本月：</span>
              <el-statistic :value="statsData.thisMonthFee" suffix="元" :precision="0"></el-statistic>
            </div>
            <div class="statistics-block">
              <span class="label">上月：</span>
              <el-statistic :value="statsData.lastMonthFee" suffix="元" :precision="0"></el-statistic>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <custom-table :hasChannel="true" has-organization="true" ref="customTable" :customOptions="customOptions"
      :columns="columns" style="height: calc(100vh - 280px)" excel-type="HitchRideAdverseRecord">
      <template slot="table-operation">
        <el-table-column label="操作" width="100" fixed="right">
          <div slot-scope="{ row }" class="custom-action" v-if="row.status == 1">
            <el-button type="text" @click="actionFn({ type: 'detail', row: row })">详情</el-button>
          </div>
          <div v-else>-</div>
        </el-table-column>
      </template>
      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'created'">
          {{ row[item.prop] | filterTime }}
        </template>
        <template v-else-if="item.prop === 'code'">
          <span @dblclick="$utils.dblclickCopy">{{ row.code || '-' }}</span>
          <div>{{ row.channelName }}</div>
        </template>
        <template v-else-if="item.prop === 'status'">
          <span v-if="row[item.prop] || row[item.prop] === 0" :style="{ color: row[item.prop] == '0' ? '#f56c6c' : '#67c23a' }">{{
            row[item.prop] ==
              '0' ? "失败" : "成功" }}</span>
          <span v-else>-</span>
        </template>
        <template v-else-if="item.prop === 'auditStatus'">
          <span v-if="row[item.prop]" :style="{ color: row[item.prop] == '通过' ? '#67c23a' : '#f56c6c' }">{{
            row[item.prop]
            }}</span>
          <span v-else>-</span>
        </template>
        <template v-else-if="item.prop === 'riskLevel'">
          <div v-if="row.riskLevel" class="risk-level-tag"
            :style="{ backgroundColor: getRiskLevelColor(row.riskLevel, 'label') }">{{ row.riskLevel }}</div>
          <div v-else>-</div>
        </template>

        <template v-else>{{ row[item.prop] || row[item.prop] === 0 ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>

    <el-drawer title="" :visible.sync="showCancel" :show-close="false" :size="1100">
      <div class="flex-between" style="margin-bottom: 16px;">
        <h2>背景审核报告</h2>
        <el-button size="small" @click="showCancel = false">关闭</el-button>
      </div>
      <driverBackgroundPage v-if="showCancel" :driverInfo="driverInfo" :adverseRecord="adverseRecord" :searchShow="false" />
    </el-drawer>
  </div>
</template>

<script>
import DriverBackgroundPage from "@/page/resource/driver/components/detail/driverBackgroundPage/index.vue";
export default {
  name: "adverseRecord",
  components: {
    DriverBackgroundPage
  },
  data() {
    return {
      loading: false,
      // 统计数据
      statsData: {
        thisMonthCount: 0,
        lastMonthCount: 0,
        thisMonthFee: 0,
        lastMonthFee: 0
      },

      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/hitchRide/adverse/record",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          {
            type: "input",
            field: "name",
            name: "司机姓名",
            value: "",
            clearable: true,
          },
          {
            type: "input",
            field: "idCard",
            name: "司机身份证号",
            value: "",
            clearable: true,
          },
          {
            type: "select",
            field: "status",
            name: "审核状态",
            value: "",
            option: [
              { label: "成功", value: "1" },
              { label: "失败", value: "0" }
            ],
            clearable: true,
          },
          {
            type: "select",
            field: "riskLevel",
            name: "风险等级",
            value: "",
            option: this.$const.RISKLEVELLIST,
            clearable: true,
          },
          {
            type: "select",
            field: "auditStatus",
            name: "审核结果",
            value: "",
            option: [
              { label: "通过", value: "1" },
              { label: "未通过", value: "2" },
            ],
            clearable: true,
          },
        ],
      },
      // 表头
      columns: [
        { prop: "code", label: "记录ID", minWidth: 160 },
        { prop: "name", label: "司机姓名", minWidth: 100 },
        { prop: "idCard", label: "身份证号", minWidth: 120 },
        { prop: "phone", label: "联系电话", minWidth: 100 },
        { prop: "status", label: "审核状态", minWidth: 80 },
        { prop: "score", label: "风险分值", minWidth: 80 },
        { prop: "riskLevel", label: "风险等级", minWidth: 80 },
        { prop: "auditStatus", label: "审核结果", minWidth: 80 },
        { prop: "operator", label: "审核人", minWidth: 120 },
        { prop: "created", label: "审核时间", minWidth: 130 },
      ],

      showCancel: false,
      rowData: {},
      driverInfo: {},
      adverseRecord: {},
    };
  },
  async created() {
    this.getLabel();
    this.getStatisticsData();
  },
  methods: {
    getRiskLevelColor(riskLevel, key = 'value', returnKey = 'color') {
      if (!riskLevel) {
        return ''
      }
      return this.$const.RISKLEVELLIST.find(item => item[key] === riskLevel)[returnKey];
    },
    /**
     * @description 获取统计数据
     */
    async getStatisticsData() {
      this.loading = true;
      try {
        const url = "/api/v1/manage/hitchRide/adverse/record/count";
        const { code, data } = await this.$axios.get(url);
        if (code === 1) {
          this.statsData = {
            thisMonthCount: data.thisMonthCount || 0,
            lastMonthCount: data.lastMonthCount || 0,
            thisMonthFee: data.thisMonthFee || 0,
            lastMonthFee: data.lastMonthFee || 0
          };
        }
      } catch (error) {
        console.error("获取统计数据失败", error);
      } finally {
        this.loading = false;
      }
    },
    async getLabel() {
      const url = "/api/v1/manage/driver/hitchRide/feedback/label";
      const { code, data } = await this.$axios.get(url);
      if (code === 1 && data) {
        this.customOptions.search[2].option = data.split(",").map((item) => {
          return {
            label: item,
            value: item,
          };
        });
      }
    },
    actionFn({ type, row }) {
      console.log('row', row);
      switch (type) {
        case "detail":
          this.driverInfo = {
            id: row.driverId,
            name: row.name,
            idCard: row.idCard,
            phone: row.phone,
          }
          this.adverseRecord = {
            code: row.code,
            score: row.score,
            updated: row.updated,
            riskLevel: row.riskLevel,
          }
          this.rowData = { ...row };
          this.rowData.feedbackLabel = row.feedbackLabel ? row.feedbackLabel.split(",") : row.feedbackLabel;
          this.rowData.feedbackImg = row.feedbackImg ? row.feedbackImg.split(",").map(item => {
            return this.mixinQiniuImg(item)
          }) : '',
            this.showCancel = true;
          break;
      }
    },
    /**
     * 状态改变
     */

    handClose() {
      this.rowData = {};
      this.showCancel = false;
    },
  },
};
</script>

<style scoped lang="less">
.statistics {
  margin-bottom: 20px;
  display: flex;
  gap: 40px;

  .statistics-item {
    width: 280px;
    
    /deep/ .el-card {
      border-radius: 10px;
      border: 1px solid #e4e7ed;
      background: #fff;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      transition: all 0.3s ease;
      
      .el-card__body {
        padding: 20px 24px;
      }
    }

    .statistics-title {
      font-size: 15px;
      font-weight: 600;
      color: #303133;
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      
      &::before {
        content: '';
        width: 4px;
        height: 16px;
        background: @color-primary;
        border-radius: 2px;
        margin-right: 10px;
      }
    }

    .statistics-content {
      display: flex;
      align-items: center;
      gap: 32px;

      .statistics-block {
        display: flex;
        align-items: baseline;
        gap: 6px;

        .label {
          font-size: 14px;
          color: #909399;
          white-space: nowrap;
        }

        /deep/ .el-statistic {
          .el-statistic__content {
            font-size: 24px;
            font-weight: 600;
            color: @color-primary;

            .el-statistic__suffix {
              margin-left: 4px;
              font-size: 13px;
              font-weight: 400;
              color: #909399;
            }
          }
        }
      }
    }

    &:hover {
      /deep/ .el-card {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }
    }
  }
}

.risk-level-tag {
  width: 70px;
  height: 30px;
  border-radius: 4px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
